var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 7",
    cx: 56,
    cy: 56,
    r: 56,
    style: {
      fill: "#ffce00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 154",
    d: "m177.083 115.146-32.728-32.728s-10.425 17.019-19.036 22.47-41.308 17.926-41.308 17.926l15.454 15.454-2.4 10.55L124.256 176a55.812 55.812 0 0 0 53.063-55.743c0-1.721-.083-3.426-.236-5.111z",
    transform: "translate(-65.696 -64.449)",
    style: {
      fill: "#ffa300"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 25"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 155",
    d: "M183.438 324.886h6.769v4.514h-6.769z",
    transform: "translate(-143.446 -254.056)",
    style: {
      fill: "#283d66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 156",
    d: "M230.19 82.5v65.073l-3.836-3.881c-10.334-10.289-19.706-15.93-28.054-17.1l-4.513-9.792.587-1.76 3.926-11.553c8.348-1.173 17.72-6.814 28.054-17.1z",
    transform: "translate(-151.539 -64.512)",
    style: {
      fill: "#e6f2ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 157",
    d: "M381.46 221.39h9.025v4.51h-9.025z",
    transform: "translate(-298.296 -173.124)",
    style: {
      fill: "#ffea80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 158",
    d: "m375.737 165.437 6.769-4.515 2.5 3.754-6.769 4.515z",
    transform: "translate(-293.821 -125.839)",
    style: {
      fill: "#ffea80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 159",
    d: "m375.8 268.361 2.5-3.754 6.769 4.515-2.5 3.754z",
    transform: "translate(-293.873 -206.918)",
    style: {
      fill: "#fc6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 160",
    d: "m121.542 273.581 4.876 24.377h10.874v-24.82z",
    transform: "translate(-95.044 -213.59)",
    style: {
      fill: "#405580"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 161",
    d: "M230.19 231.739v32.536l-3.836-3.881c-10.334-10.289-19.706-15.93-28.054-17.1l-4.513-9.792.587-1.76h35.816z",
    transform: "translate(-151.539 -181.217)",
    style: {
      fill: "#cce6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 162",
    d: "M381.46 231.739h9.025V234h-9.025z",
    transform: "translate(-298.296 -181.217)",
    style: {
      fill: "#fc6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 163",
    d: "M97.842 179.02H80.874a11.282 11.282 0 1 0 0 22.564h16.968a20.814 20.814 0 0 1 3.339.271v-23.106a20.831 20.831 0 0 1-3.339.271z",
    transform: "translate(-54.42 -139.779)",
    style: {
      fill: "#ff8066"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 164",
    d: "M69.592 231.739h31.589v11.553a20.814 20.814 0 0 0-3.339-.271H80.874a11.286 11.286 0 0 1-11.282-11.282z",
    transform: "translate(-54.42 -181.217)",
    style: {
      fill: "#e63950"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventAd);
export default __webpack_public_path__ + "static/media/event-ad.3489e9b60dffb82d022033c55d938d4d.svg";
export { ForwardRef as ReactComponent };